import React from 'react';
import {
  Label,
  ButtonToolbar,
  Button,
  Clearfix,
} from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

const propTypes = exact({
  timeEntryId: PropTypes.number.isRequired,
  timeEntryKey: PropTypes.string.isRequired,

  dispatchDeleteTimeEntry: PropTypes.func.isRequired,
  dispatchHideTimeEntryEditorModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,

  supervisorId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,
});

const UserTimeEntryDeleteModal = (props) => {
  const {
    errorMessage,
    timeEntryId,
    timeEntryKey,
    dispatchDeleteTimeEntry,
    dispatchHideTimeEntryEditorModal,
    supervisorId,
    userId,
    originDate,
  } = props;

  const handleDelete = () => {
    dispatchDeleteTimeEntry(timeEntryId, timeEntryKey, supervisorId, userId, originDate);
  };

  return (
    <div name="deleteMessage">
      <p>
        Are you sure you want to delete?
      </p>
      <Clearfix>
        <ButtonToolbar className="pull-right">
          <Button onClick={dispatchHideTimeEntryEditorModal}>Cancel</Button>
          <Button bsStyle="danger" onClick={() => { return handleDelete(); }}>Confirm</Button>
        </ButtonToolbar>
      </Clearfix>
      <Label>{errorMessage}</Label>
    </div>
  );
};

UserTimeEntryDeleteModal.propTypes = propTypes;

export default UserTimeEntryDeleteModal;
